import React from 'react'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-tree"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>BAUMSTARK SOFTWARE</h1>
                <p>Individuelle Software für Ihr Business</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('leistungen')}}>Leistungen</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('projekte')}}>Projekte</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('person')}}>Person</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('kontakt')}}>Kontakt</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: React.PropTypes.func,
    timeout: React.PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js